import {Box} from '@mui/material';
import AppCard from 'main/core/AppCard';
import AppLinearProgress from 'main/core/AppLinearProgress';
import PropTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';

const ReadyStock = ({readyStockData}) => {
  const totalValue = readyStockData.reduce((acc, item) => acc + item.value, 0);

  return (
    <>
      <Box
        component='h2'
        sx={{
          color: 'text.primary',
          textTransform: 'uppercase',
          fontSize: 16,
          mb: {xs: 4, sm: 4, xl: 6},
          fontWeight: Fonts.BOLD,
        }}
      >
        Export Readiness
      </Box>

      <AppCard>
        {readyStockData
          .filter((item) => item.title && item.title.trim() !== '')
          .map((data) => {
            const percentage =
              totalValue > 0 ? Math.round((data.value * 100) / totalValue) : 0;

            return (
              <Box key={data.title} sx={{mb: 6, '&:last-child': {mb: 0}}}>
                <Box
                  sx={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      mb: 2,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'space-between',
                    }}
                  >
                    <Box>{data.title}</Box>
                    <Box
                      component='span'
                      sx={{
                        color: 'text.secondary',
                      }}
                    >
                      {`${percentage}%`}
                    </Box>
                  </Box>
                  <AppLinearProgress
                    value={percentage}
                    thickness={10}
                    activeColor={data.color}
                  />
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'flex-end',
                  }}
                >
                  <Box
                    component='span'
                    sx={{
                      ml: 2,
                      // fontWeight: Fonts.LIGHT,
                    }}
                  >
                    {data.value}
                  </Box>
                  <Box
                    component='span'
                    sx={{
                      ml: 2,
                      color: 'text.secondary',
                    }}
                  >
                    / {totalValue}
                  </Box>
                </Box>
              </Box>
            );
          })}
      </AppCard>
    </>
  );
};

export default ReadyStock;

ReadyStock.propTypes = {
  readyStockData: PropTypes.array,
};
